import englishMessages from 'shared/translations/en.json';
import arabMessages from 'shared/translations/ar.json';

import { ACTION_TYPE } from '../actions/actionTypes';

const translation = {
  EN: { ...englishMessages },
  AR: { ...arabMessages },
};

const languageReducer = (state = [], action) => {
  switch (action.type) {
    case ACTION_TYPE.SWITCH_LANGUAGE:
      return {
        ...state,
        language: {
          ...state.language,
          locale: action.payload.locale,
          messages: action.payload.messages,
        },
      };
    case ACTION_TYPE.STORE_TRANSLATION:
      return {
        ...state,
        translation: action.payload.translation,
        language: {
          ...state.language,
          messages: action.payload.messages,
        },
      };
    case ACTION_TYPE.STORE_TRANSLATION_FAIL:
      return {
        ...state,
        translation,
        language: {
          ...state.language,
          messages: {
            [state.language.locale]: { ...translation[state.language.locale] },
          },
        },
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default languageReducer;
